import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './utils/bootstrap.scss';
import App from './App';
import { BrowserRouter } from "react-router-dom";
import {
  ModuleRegistry,
  ClientSideRowModelModule,
  CellStyleModule,
  PaginationModule,
  ColumnAutoSizeModule,
  NumberFilterModule,
  DateFilterModule,
  CustomFilterModule,
  QuickFilterModule,
  TextFilterModule,
  provideGlobalGridOptions
} from 'ag-grid-community';

ModuleRegistry.registerModules([
  ClientSideRowModelModule,
  CellStyleModule,
  PaginationModule,
  ColumnAutoSizeModule,
  QuickFilterModule,
  NumberFilterModule,
  DateFilterModule,
  CustomFilterModule,
  TextFilterModule
])
provideGlobalGridOptions({ theme: "legacy" });
ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
  ,
  document.getElementById('root')
);
